// component
import TableCard from "../tableCard/TableCard";
import { DeleteIcon, EnvelopeIcon } from "../kits/Icons";
import { ReactSelect, CreatableReactSelect } from "../kits/Inputs/Inputs";
import { EditIcon } from "../kits/Icons";
import CustomButton from "../kits/button/CustomButton.jsx";
import CustomerInfoModal from "./CustomerInfoModal.jsx";
import AddEditCustomerModal from "./customerModal/AddEditCustomerModal";
import useAxios from "../../services/useAxios";
import { CustomTooltip } from "../kits/tooltip/CustomTooltip";
import ToastCustomize from "../kits/ToastCustomize";
import ColorSchema from "../kits/Color";
import SendMassage from "./customerModal/SendMassage";
import AuthenticationContext from "../../Authentication/AuthenticationContext.ts";

import {
  TimeStampToJalali,
  translateToReactSelect,
} from "../../utils/helperFunction";
import Loader from "../../utils/Loader";
// react
import { useState, useEffect, useContext } from "react";
import Swal from "sweetalert2";
// style
import "./CustomerList.scss";
export default function CustomerList({
  tagOption,
  userOption,
  bankName,
  content,
  setContent,
  customerUpdater,
  setCustomerUpdater,
  setTagUpdater,
  loading,
  setLoading,
}) {
  const { userInfo } = useContext(AuthenticationContext);

  const [show, setShow] = useState(false);
  const [sendMsgModal, setSendMsgModal] = useState(false);
  const [selected, setSelected] = useState({});
  // const [loading, setLoading] = useState(false);

  const { execute: insertHashtag } = useAxios("api/Insert_tagLink");
  const { execute: deleteTag } = useAxios("api/Delete_tagLink");

  const { execute: deleteCustomer } = useAxios("api2/delete_customer");
  const { execute: addTagApi } = useAxios("api/Insert_tag");
  const addTagFunc = (title, customerId) => {
    addTagApi({ text: title, status: 1 }).then((result) => {
      if (result.status == 1) {
        console.log("rr**", result.result.id);
        insert_tagLinkFun("", customerId, result.result.id);
        ToastCustomize({
          mainText: "تگ با موفقیت اضافه شد.",
          duration: 2000,
          toastType: "success",
          color: "success",
          position: "top-center",
          hasHeader: false,
        });
        setTagUpdater((prev) => !prev);
      } else {
        ToastCustomize({
          mainText: "مشکلی در ثبت تگ پیش آمده است.",
          duration: 2000,
          toastType: "danger",
          color: "danger",
          position: "top-center",
          hasHeader: false,
        });
      }
    });
  };
  // background color
  const selectBg = (status) => {
    switch (status) {
      case "0":
        return "blue_custom";
        break;
      case "-2":
        return "secondary_custom";
        break;
    }
  };
  // name or companiname
  const select_name = (firstname, lastname, corporate, companiname) => {
    // 0=false
    // 1=true
    let name = "";
    if (corporate == "0") {
      name = `${firstname}  ${lastname}`;
    } else {
      name = `${companiname}-(${firstname} ${lastname})`;
    }
    return name;
  };

  // state
  const [Labels, setLabels] = useState([]);
  const [selectedLable, setSelectedLable] = useState();
  // const [content, setContent] = useState([]);
  const [header, setHeader] = useState([
    {
      type: "title",
      // title: select_title(corporate),
      title: "عنوان",
      name: "companiTitle",
    },
    {
      type: "title",
      title: " تاریخ ثبت ",
      name: "mtm",
    },
    {
      type: "title",
      title: " تاریخ اولین فاکتور   ",
      name: "first_factor_tm",
    },
    {
      type: "title",
      title: " تعدادخرید  ",
      name: "purchase_count",
    },
    {
      type: "title",
      title: " حجم خرید   ",
      name: "purchase_volume",
    },
    {
      type: "title",
      title: " شماره تماس    ",
      name: "mobile",
    },

    {
      type: "title",
      title: "  کاربران مرتبط    ",
      name: "Relatedusers",
    },
    {
      type: "descrioptin",
      title: " عملیات ",
      name: "operation",
    },
  ]);

  useEffect(() => {
    if (userInfo.userRoll.includes(10)) {
      let array = header;
      array.push({
        type: "descrioptin",
        title: " برچسب ها    ",
        name: "lable",
      });
      setHeader(array);
    }
  }, []);

  const changeHandler = (name, value, index, action, customerId, tagid) => {
    let temp = [...content];
    temp[index][name] = value;

    // setContent(temp);
    if (action.action == "select-option") {
      insert_tagLinkFun(temp, customerId, action.option.value);
      setCustomerUpdater((prev) => !prev);
    } else if (action.action == "remove-value") {
      delete_tagLinkFun(temp, customerId, action.removedValue.id);
      setCustomerUpdater((prev) => !prev);
    } else if (action.action == "create-option") {
      addTagFunc(action.option.label, customerId);
      setCustomerUpdater((prev) => !prev);
    }
  };
  /**
   *TODO Checking that the date is not empty and converting it to Shamsi
   */
  // const checkedDate = (date) => {
  //   let d = "";
  //   if (date) {
  //     d = TimeStampToJalali(parseInt(date) * 1000);
  //     console.log(" TimeStampToJalali", d);
  //   }
  //   return d;
  // };
  // operation
  const returnJSX = (customerId, content) => {
    return (
      <div className="d-flex justify-content-center">
        {/* {loading ? <Loader /> : ""} */}

        {userInfo.userRoll.includes(7) && (
          <div>
            <CustomerInfoModal
              customerData={{
                ...content,
                main_uid: userOption?.filter(
                  (v) => v.value == content.main_uid
                ),
                tag_links: tagOption?.filter((v) =>
                  content.tag_links.map((t) => t.TagId).includes(v.value)
                ),
              }}
              bankName={bankName}
              setCustomerUpdater={setCustomerUpdater}
            ></CustomerInfoModal>
          </div>
        )}
        {userInfo.userRoll.includes(6) && (
          <CustomButton className="shadow-none">
            <CustomTooltip title="ویرایش" placement="top" color="red_custom">
              <div
                className="cursor-pointer"
                onClick={() => {
                  setShow(true);
                  setSelected(content);
                }}
              >
                {" "}
                <EditIcon color="white"></EditIcon>
              </div>
            </CustomTooltip>
          </CustomButton>
        )}
        {userInfo.userRoll.includes(8) &&
          (content.status == "-2" ? (
            <CustomButton className="shadow-none">
              <CustomTooltip
                title="   عملیات غیر فعال است"
                placement="top"
                color="red_custom"
              >
                <div style={{ cursor: "not-allowed" }}>
                  <DeleteIcon color="white"></DeleteIcon>
                </div>
              </CustomTooltip>
            </CustomButton>
          ) : (
            <CustomButton className="shadow-none">
              <CustomTooltip title="حذف" placement="top" color="red_custom">
                <div
                  onClick={() => {
                    Swal.fire({
                      title: "کاربر مورد نظر حذف شود؟",
                      showDenyButton: true,
                      confirmButtonText: "بله",
                      denyButtonText: `خیر`,
                    }).then((result) => {
                      if (result.isConfirmed) {
                        deleteCustomerFun(customerId);
                      }
                    });
                  }}
                >
                  <DeleteIcon color="white"></DeleteIcon>
                </div>
              </CustomTooltip>
            </CustomButton>
          ))}
        {userInfo.userRoll.includes(9) &&
          (content.status == "-2" ? (
            <CustomButton className="shadow-none">
              <CustomTooltip
                title="   عملیات غیر فعال است"
                placement="top"
                color="red_custom"
              >
                <div>
                  <EnvelopeIcon color="white"></EnvelopeIcon>
                </div>
              </CustomTooltip>
            </CustomButton>
          ) : (
            <CustomButton
              className="shadow-none"
              data-bs-toggle="modal"
              data-bs-target="#send-message"
              onClick={() => {
                console.log("first");
                setSendMsgModal(true);
                setSelected(content);
              }}
            >
              <CustomTooltip title="   پیام" placement="top" color="red_custom">
                <div>
                  <EnvelopeIcon color="white"></EnvelopeIcon>
                </div>
              </CustomTooltip>
            </CustomButton>
          ))}
      </div>
    );
  };
  // reactselect
  const returnSelect = (index, customerId, value) => {
    let tempArray = [];
    let pushValue = [];
    let tagOptionArray = [{ value: "0", label: "ae" }];
    tempArray = value.tag_links.map((v) => {
      tagOption.map((vl) => {
        if (v.TagId == vl.value) {
          pushValue = [
            ...pushValue,
            {
              TagId: v.TagId,
              label: vl.label,
              value: vl.value,
              id: v.id,
            },
          ];
        }
      });
      // return v.TagId;
    });
    // console.log("pushValue", pushValue);

    tagOptionArray = tagOption.filter((t) => tempArray.includes(t.value));

    return (
      <div style={{ color: ColorSchema.dark_custom }}>
        <CreatableReactSelect
          itemsList={tagOption}
          inputContainer=""
          inputSize="lg"
          isMulti={true}
          inputValue={pushValue}
          onChangeFunc={(e, action) => {
            changeHandler("tag_links", e, index, action, customerId);
          }}
        />
      </div>
    );
  };
  // api

  // insert tag
  async function insert_tagLinkFun(temp, customerId, tagid) {
    setLoading(true);
    await insertHashtag({
      TagId: tagid,
      linkId: customerId,
      type: 2,
    }).then((res) => {
      setContent(temp);
      setLoading(false);
      console.log("result**", res.result.id);
    });
  }
  // del tag
  async function delete_tagLinkFun(temp, customerId, tagid) {
    await deleteTag({
      conditions: `id/=/${tagid}`,
      // TagId: tagid,
      // linkId: customerId,
    }).then((res) => {
      if (res.status == 1) {
        setContent(temp);
        // setCustomerUpdater((prev) => !prev);
      }
    });
  }
  // deletCustomrer
  async function deleteCustomerFun(customerId) {
    await deleteCustomer({
      customer_id: customerId,
    }).then((res) => {
      if (res.status == 1) {
        setCustomerUpdater((prev) => !prev);
        ToastCustomize({
          mainText: "کاربر با موفقیت حذف شد",
          duration: 4000,
          toastType: "success",
          color: "success",
          position: "top-center",
          hasHeader: false,
        });
      } else {
        ToastCustomize({
          mainText: " مشکلی در انجام عملیات پیش آمده است   ",
          duration: 4000,
          toastType: "danger",
          color: "danger",
          position: "top-center",
          hasHeader: false,
        });
      }
    });
  }
  console.log("*****testssss", selected);
  return (
    <div>
      {[...content].reverse()?.map((value, index) => {
        return (
          <TableCard
            column={header}
            content={{
              ...value,
              operation: returnJSX(value.id, value),
              companiTitle: select_name(
                value.firstname,
                value.lastname,
                value.corporate,
                value.company_name
              ),
              lable: returnSelect(index, value.id, value),
              Relatedusers: value.main_uid.fullname,
              // mtm: checkedDate(value.mtm),
              // firstName: checkedDate(value.first_factor_tm),
              mtm: value.mtm
                ? TimeStampToJalali(parseInt(value.mtm) * 1000)
                : "---",
              first_factor_tm: value.first_factor_tm
                ? TimeStampToJalali(parseInt(value.first_factor_tm) * 1000)
                : "---",
            }}
            bg={selectBg(value.status)}
            widthParent={"90%"}
            showSelect="false"
          ></TableCard>
        );
      })}
      <div>
        <AddEditCustomerModal
          type="edit"
          data={{
            firstName: selected?.firstname,
            lastName: selected?.lastname,
            companyName: selected?.company_name,
            companyAddress: selected?.address,
            corporate: selected?.corporate == 1 ? true : false,
            mobile: selected?.mobile,
            tell: selected?.tell,
            tags: tagOption?.filter((t) =>
              selected?.tag_links?.map((v) => v.TagId).includes(t.value)
            ),
            // main_uid: userOption?.filter((v) => v.value == selected.main_uid),
            main_uid: [
              {
                value: selected?.main_uid?.id,
                label: selected?.main_uid?.fullname,
              },
            ],

            bankAccountApi: selected.bank_accounts,

            bankAccount: [],
            customer_id: selected?.id,
            economical_number: selected?.economical_number ?? "",
            identification_code: selected?.identification_code ?? "",
            postalCode: selected?.postal_code ?? "",
          }}
          show={show}
          setShow={setShow}
          headerText="ویرایش مشتری"
          tagOption={tagOption}
          userOption={userOption}
          bankName={bankName}
          setCustomerUpdater={setCustomerUpdater}
          setTagUpdater={setTagUpdater}
        />
      </div>
      <div>
        <SendMassage
          show={sendMsgModal}
          setShow={setSendMsgModal}
          selected={selected}
        />
      </div>
    </div>
  );
}
